const TIEMPOS_DEMORA = [
    { value: '00:05', label: '05-10 mins' },
    { value: '00:10', label: '10-15 mins' },
    { value: '00:15', label: '15-20 mins' },
    { value: '00:20', label: '20-25 mins' },
    { value: '00:25', label: '25-30 mins' },
    { value: '00:30', label: '30-45 mins' },
];

export default TIEMPOS_DEMORA;